class LiveViewers extends HTMLElement {
  connectedCallback() {
    this.countEl = this.querySelector('[ref="count"]');
    if (!this.countEl) return;

    this.minDay = this.#readInt('minDay', 0);
    this.maxDay = this.#readInt('maxDay', this.minDay);
    this.minNight = this.#readInt('minNight', 0);
    this.maxNight = this.#readInt('maxNight', this.minNight);
    this.nightStart = this.#readInt('nightStart', NaN);
    this.nightEnd = this.#readInt('nightEnd', NaN);
    this.interval = Math.max(1000, this.#readInt('interval', 6000));
    this.maxStep = Math.max(1, this.#readInt('maxStep', 3));

    if (this.maxDay < this.minDay) [this.minDay, this.maxDay] = [this.maxDay, this.minDay];
    if (this.maxNight < this.minNight) [this.minNight, this.maxNight] = [this.maxNight, this.minNight];

    const [min, max] = this.#activeRange();
    this.count = this.#randomInt(min, max);
    this.#render();

    this.timer = setInterval(() => this.#tick(), this.interval);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  #readInt(key, fallback) {
    const value = parseInt(this.dataset[key], 10);
    return Number.isNaN(value) ? fallback : value;
  }

  #isNight() {
    if (Number.isNaN(this.nightStart) || Number.isNaN(this.nightEnd) || this.nightStart === this.nightEnd) {
      return false;
    }

    const hour = new Date().getHours();

    if (this.nightStart < this.nightEnd) {
      return hour >= this.nightStart && hour < this.nightEnd;
    }

    // Night window wraps past midnight, e.g. 22 -> 6.
    return hour >= this.nightStart || hour < this.nightEnd;
  }

  #activeRange() {
    return this.#isNight() ? [this.minNight, this.maxNight] : [this.minDay, this.maxDay];
  }

  #randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  #tick() {
    const [min, max] = this.#activeRange();
    let next = this.count + this.#randomInt(-this.maxStep, this.maxStep);
    next = Math.max(min, Math.min(max, next));

    // Nudge instead of stalling when clamping repeatedly cancels the step out.
    if (next === this.count && max > min) {
      next = Math.max(min, Math.min(max, next + (Math.random() < 0.5 ? -1 : 1)));
    }

    this.count = next;
    this.#render();
  }

  #render() {
    this.countEl.textContent = this.count;
  }
}

if (!customElements.get('live-viewers')) {
  customElements.define('live-viewers', LiveViewers);
}
